
import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';

@Component
export default class CarDimensionsField extends Vue {
  val = '';

  car_dimensions = {
    length: 0, // 长
    width: 0, // 宽
    height: 0, // 高
  };

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  form!: any;

  @Prop()
  placeholder!: string;

  @Model('change', {
    type: Object,
  })
  value!: any;

  @Watch('val')
  watchVal() {
    this.$emit('update', this.val);
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
     const { length, width, height } = this.value;
     this.car_dimensions = {
       length,
       width,
       height,
     };
      // this.val = this.value;
    } else {
      this.val = '';
    }
  }

  changeInput() {
    this.$emit('changeDinebssins', this.car_dimensions);
  }

  mounted() {
    this.watchValue();
  }
}
